import { FunctionComponent } from 'react'
import { useHistory } from 'react-router-dom'
import { Text } from '@conexasaude/conexa-hero'
import { Illustration } from '@/components/HideIllustrationsExternal'
import Modal from '@/components/Modal'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { useStyles } from './styles'
import { DeviceWarningModalProps } from './types'

const DeviceWarningModal: FunctionComponent<
  DeviceWarningModalProps
> = props => {
  const { consultationId } = props

  const { closeModal } = useModalContext()
  const history = useHistory()
  const styles = useStyles()

  const handleConfirm = () => {
    if (consultationId) {
      history.push(`/meus-atendimentos/atendimento/${consultationId}`)

      return
    }

    history.push('/meus-atendimentos')
  }

  return (
    <Modal
      id="DEVICE_WARNING"
      onDismiss={closeModal}
      primaryActionLabel="Ir para consultas"
      primaryAction={handleConfirm}
    >
      <div css={styles.illustrationWrapper}>
        <Illustration name="user-phonesignal-alert" width="172px" />
      </div>
      <Text css={styles.caption}>
        Conexão instável. Por favor, verifique o sinal de internet.
      </Text>
    </Modal>
  )
}

export { DeviceWarningModal }
